import * as React from "react";
import Component from "../../AbstractComponent";
import ChargeClassContainer from "../../../Entity/Entities/Charge/ChargeClass/ChargeClassContainer";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
// import PersonLookup from "../Lookup/PersonLookup";
// import CompanyLookup from "../Lookup/CompanyLookup";
import Searchbar from "../Searchbar/Searchbar";
import { DatePickerComponent } from "../DatePicker/DatePickerComponent";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { ContractInterface } from "../../../Entity/Entities/Contract/ContractInterface";
import { PromptDialog } from "../Dialog/PromptDialog";
import { ChargeTypeCreate } from "../Dialog/ChargeTypeCreate";
import Formatter from "../../../Localization/Formatter";
import Constants from "../../../Action/Constants";
import { BankAccountInterface } from "../../../Entity/Entities/BankAccount/BankAccountInterface";
import Select from "../../Partials/Material/Select";
// import Radio from '@material-ui/core/Radio';
// import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from "../../Partials/Material/TextField";
import Switch from '@material-ui/core/Switch';
import { Attachment } from "../../Partials/Attachment/Attachment";
import { CoachNewCounterpartyDialog } from "../../Partials/Dialog/CoachNewCounterpartyDialog";



export default class ChargeDetails extends Component {
	public state = {
    amountForCharge: "",
    invoiceDateForCharge: "",
    invoiceNumberForCharge: "",
    vatForCharge: "",
    vatPercentageForCharge: "",
    isInvoice: false,
    currencyIdForCharge: "",
    showChargeOwnerChoice: true,
    paymentClassId: "",
    chargeClassId: "",
    chargeOwnerChoice: "person",
    selectedPersonForCharge: null,
    selectedCompanyForCharge: null,
    selectedCounterpartyForCharge: null,
    selectedPayment: null,
    typeIdForCharge: "",
    selectedEntityForCharge: null,
    periodForCharge: "",
    firstDateForCharge: null,
    dateOfPeriodForCharge: null,
    descriptionForCharge: "",
    descriptionForChargeIsManuallyChanged: false,
    isCreateChargeTypePopupOpen: false,
    renderChargeType: true,
    chargeTypeSelectField: null,
    isSettle: false,
    hasSettlementType: false,
    isLocked: false,
    isRemoved: false,
    charge: null,
    showInvoiceSwitch: false,
    hasSavingsType: false,
    attachments: [],
    openCoachCreateNewCounterparty: false
  };

  constructor(public props) {
    super(props);
  }

  public componentWillMount() {
    this.setState({
      amountForCharge: this.props.amountForCharge,
      invoiceDateForCharge: this.props.invoiceDateForCharge,
      invoiceNumberForCharge: this.props.invoiceNumberForCharge,
      vatForCharge: this.props.vatForCharge,
      vatPercentageForCharge: this.props.vatPercentageForCharge,
      isInvoice: this.props.isInvoice,
      currencyIdForCharge: this.props.currencyIdForCharge,
      showChargeOwnerChoice: this.props.showChargeOwnerChoice,
      paymentClassId: this.props.paymentClassId,
      chargeClassId: this.props.chargeClassId,
      chargeOwnerChoice: this.props.chargeOwnerChoice,
      selectedPersonForCharge: this.props.selectedPersonForCharge,
      selectedCompanyForCharge: this.props.selectedCompanyForCharge,
      selectedCounterpartyForCharge: this.props.selectedCounterpartyForCharge,
      selectedPayment: this.props.selectedPayment,
      typeIdForCharge: this.props.typeIdForCharge,
      selectedEntityForCharge: this.props.selectedEntityForCharge,
      periodForCharge: this.props.periodForCharge,
      firstDateForCharge: this.props.firstDateForCharge,
      dateOfPeriodForCharge: this.props.dateOfPeriodForCharge,
      descriptionForCharge: this.props.descriptionForCharge,
      descriptionForChargeIsManuallyChanged: this.props.descriptionForChargeIsManuallyChanged,
      renderChargeType: this.props.renderChargeType,
      isSettle: this.props.isSettle,
      hasSettlementType: this.props.hasSettlementType,
      isLocked: this.props.isLocked,
      isRemoved: this.props.isRemoved,
      charge: this.props.charge,
      showInvoiceSwitch: this.props.showInvoiceSwitch,
      hasSavingsType: this.props.hasSavingsType,
      attachments: this.props.attachments
    }, () => {
      this.setState({
        chargeOwnerChoice: this.state.selectedCompanyForCharge ? "company" : "person"
      })
    });
	}

	public componentWillReceiveProps(nextProps) {
    this.setState({
      amountForCharge: nextProps.amountForCharge,
      invoiceDateForCharge: nextProps.invoiceDateForCharge,
      invoiceNumberForCharge: nextProps.invoiceNumberForCharge,
      vatForCharge: nextProps.vatForCharge,
      vatPercentageForCharge: nextProps.vatPercentageForCharge,
      isInvoice: nextProps.isInvoice,
      currencyIdForCharge: nextProps.currencyIdForCharge,
      showChargeOwnerChoice: nextProps.showChargeOwnerChoice,
      paymentClassId: nextProps.paymentClassId,
      chargeClassId: nextProps.chargeClassId,
      chargeOwnerChoice: this.state.selectedCompanyForCharge ? this.state.selectedCompanyForCharge ? "company" : "person"  : nextProps.chargeOwnerChoice,
      selectedPersonForCharge: nextProps.selectedPersonForCharge,
      selectedCompanyForCharge: nextProps.selectedCompanyForCharge,
      selectedCounterpartyForCharge: nextProps.selectedCounterpartyForCharge,
      selectedPayment: nextProps.selectedPayment,
      typeIdForCharge: nextProps.typeIdForCharge,
      selectedEntityForCharge: nextProps.selectedEntityForCharge,
      periodForCharge: nextProps.periodForCharge,
      firstDateForCharge: nextProps.firstDateForCharge,
      dateOfPeriodForCharge: nextProps.dateOfPeriodForCharge,
      descriptionForCharge: nextProps.descriptionForCharge,
      renderChargeType: nextProps.renderChargeType,
      isSettle: nextProps.isSettle,
      hasSettlementType: nextProps.hasSettlementType,
      isLocked: nextProps.isLocked,
      isRemoved: nextProps.isRemoved,
      charge: nextProps.charge,
      showInvoiceSwitch: nextProps.showInvoiceSwitch,
      hasSavingsType: nextProps.hasSavingsType,
      attachments: nextProps.attachments
    })
  }

  public selectDate = (date: Date, identifier: string): void => {
		if(typeof this.props.selectDate === "function") {
			return this.props.selectDate.call(this, date, identifier);
		}
	}

	public changeAmountForCharge = (event): void => {
		if(typeof this.props.changeAmountForCharge === "function") {
			return this.props.changeAmountForCharge.call(this, event);
		}
  }

  public changeInvoiceNumberForCharge = (event): void => {
		if(typeof this.props.changeInvoiceNumberForCharge === "function") {
			return this.props.changeInvoiceNumberForCharge.call(this, event);
		}
  }

  public changeVatForCharge = (event): void => {
		if(typeof this.props.changeVatForCharge === "function") {
			return this.props.changeVatForCharge.call(this, event);
		}
  }

  public changeVatPercentageForCharge = (event): void => {
		if(typeof this.props.changeVatPercentageForCharge === "function") {
			return this.props.changeVatPercentageForCharge.call(this, event);
		}
  }

  public changeCurrencyIdForCharge = (event): void => {
		if(typeof this.props.changeCurrencyIdForCharge === "function") {
			return this.props.changeCurrencyIdForCharge.call(this, event);
		}
  }

  public changeChargeOwnerChoice = (event): void => {
    if(typeof this.props.clearSelectCounterpartyForPayment === "function") {
			this.props.clearSelectCounterpartyForPayment.call(this, event);
		}
		if(typeof this.props.changeChargeOwnerChoice === "function") {
			return this.props.changeChargeOwnerChoice.call(this, event, choice => {
				if (choice === "person") {
					return (this.refs.selectedPersonForChargeLookup as any) && (this.refs.selectedPersonForChargeLookup as any).refs.instance.ref.focus();
				}

        return (this.refs.selectedCompanyForChargeLookup as any) && (this.refs.selectedCompanyForChargeLookup as any).refs.instance.ref.focus();
			});
		}
  }

  public selectPersonForCharge = (person: PersonInterface, isManuallySelected: boolean): void => {
		if(typeof this.props.selectPersonForCharge === "function") {
			return this.props.selectPersonForCharge.call(this, person, isManuallySelected);
		}
  }

  public clearPersonForCharge = (): void => {
		if(typeof this.props.clearPersonForCharge === "function") {
			return this.props.clearPersonForCharge();
		}
  }

  public selectCompanyForCharge = (company: CompanyInterface, isManuallySelected: boolean): void => {
		if(typeof this.props.selectCompanyForCharge === "function") {
			return this.props.selectCompanyForCharge.call(this, company, isManuallySelected);
		}
  }

  public clearCompanyForCharge = (): void => {
		if(typeof this.props.clearCompanyForCharge === "function") {
			return this.props.clearCompanyForCharge();
		}
  }

  public selectCounterpartyForCharge = (entity: CompanyInterface | PersonInterface): void => {
    if (typeof this.props.selectCounterpartyForCharge === "function") {
			return this.props.selectCounterpartyForCharge.call(this, entity);
		}
  }

  public clearCounterpartyForCharge = (): void => {
    if (typeof this.props.clearCounterpartyForCharge === "function") {
			return this.props.clearCounterpartyForCharge();
		}
  }

  public changeTypeIdForCharge = (...args: any[]): void => {
		if(typeof this.props.changeTypeIdForCharge === "function") {
			return this.props.changeTypeIdForCharge.call(this, ...args);
		}
  }

  public selectEntityForCharge = (entity: PropertyInterface | UnitInterface | ContractInterface): void => {
		if(typeof this.props.selectEntityForCharge === "function") {
			return this.props.selectEntityForCharge.call(this, entity);
		}
  }

  public clearEntityForCharge = (): void => {
		if(typeof this.props.clearEntityForCharge === "function") {
			return this.props.clearEntityForCharge();
		}
  }

  public changePeriodForCharge = (event): void => {
		if(typeof this.props.changePeriodForCharge === "function") {
			return this.props.changePeriodForCharge.call(this, event);
		}
  }

  public changeDescriptionForCharge = (event): void => {
		if(typeof this.props.changeDescriptionForCharge === "function") {
			return this.props.changeDescriptionForCharge.call(this, event);
		}
  }

  public addChargeType = (chargeType): void => {
		if(typeof this.props.addChargeType === "function") {
      return this.props.addChargeType.call(this, chargeType,
                                            () => this.setState(
                                                    {
                                                      isCreateChargeTypePopupOpen: false,
                                                      // we need this hack to rerender type select to have correct presentation
                                                      renderChargeType: false
                                                    }, () => this.setState({renderChargeType: true})));
		}
  }

  public closeChargeTypeCreateDialog = (): void => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TYPE_CREATE_CLEAR,
    });

		this.setState({isCreateChargeTypePopupOpen: false});
  }

  public saveDetailsBeforeRedirect = (): void => {
    if(typeof this.props.saveDetailsBeforeRedirect === "function") {
			return this.props.saveDetailsBeforeRedirect();
		}
  }

  public changeClassIdForCharge = (event): void => {
    let chargeClassId: number = event.target.value;

    this.setState({
      chargeClassId: String(chargeClassId)
    }, () => {
      // when we change class we should automatically change type
      const typeId: number = Number(this.state.chargeClassId) == ChargeClassContainer.pickIdFromLabel("Payable") ? 
                             TypeContainer.pickIdFromLabel("Other_payable") :
                             TypeContainer.pickIdFromLabel("Other_receivable");
      this.changeTypeIdForCharge(null, {props: {value: typeId}})                       
    });
  }

  public renderCounterpartyField = (classId) => {
    return (
      <div className="search-bar-container" style={{/*margin: "-20px 0 -10px 0"*/}}>
        <Searchbar
          {...this.props}
          id="selectedCounterpartyForCharge"
          className={"scroll-to-counterpartyId"}
          // floatingLabelText={labelText}
          floatingLabelText={Number(classId) == ChargeClassContainer.pickIdFromLabel("Receivable") ? this.trans("section/charge-field/from-label") : this.trans("section/charge-field/to-label")}
          allResults={true}
          objectField={true}
          onChange={this.selectCounterpartyForCharge}
          onClear={this.clearCounterpartyForCharge}
          selectedEntity={this.state.selectedCounterpartyForCharge}
          searchParameter={"contactsSearch"}
          error={this.getErrorFor("counterpartyId")}
          showClickThroughLink={!this.props.dialogPresentation}
          searchText={this.state.selectedCounterpartyForCharge ? `${this.state.selectedCounterpartyForCharge.nameOfEntity}, ${this.state.selectedCounterpartyForCharge.displayName}` : null}
          styleInModal={"pick-object-modal"}
          createButton={"dropdown-button/newcounterparty"}
          openCoachCreateNewEntity={() => {
            this.setState({
              openCoachCreateNewCounterparty: true,
              selectedCounterparty: null
            })}
          }
        />
      </div>
    );
  }

  public renderBankAccountField = (classId) => {
    const agencyBankAccount = this.getAgencyBankAccounts().find((bankAccount: BankAccountInterface) => bankAccount?.isDefault);

    return (
      <div>
        <Select
          className="form-element form-input scroll-to-bank-account correct-label-position"
          error={this.getErrorFor("bank-account")}
          style={{width: "100%"}}
          disabled={true}
          value={agencyBankAccount?.id}
          htmlFor="bankAccount"
          label={Number(classId) == ChargeClassContainer.pickIdFromLabel("Receivable") ? this.trans("section/charge-field/to-label") : this.trans("section/charge-field/from-label")}
          name="bankAccount" 
          id="bankAccount"
        >
          <MenuItem
            key={`bankAccount-${agencyBankAccount?.id}`}
            value={agencyBankAccount?.id}
            className="filter-payment-item table-bankaccount-dropdown"
          >
          <div className="bank-account-menuitem-wrapper" style={{height: "14px"}}>
            <div>{`${agencyBankAccount?.accountId ? `${agencyBankAccount?.accountId} - ` : ""} ${agencyBankAccount?.name !== "" && agencyBankAccount?.name ? `${agencyBankAccount?.name}` : ""}`}</div>
          </div>
          </MenuItem>
        </Select>
      </div>
    );
  }

  public handleChangeIsInvoice = (): void => {
		if (typeof this.props.handleChangeIsInvoice === "function") {
			return this.props.handleChangeIsInvoice.call(this, event);
		}
	}	

  public renderCharge = (classId, _labelText) => {
    return (
      <div style={{display: "flex", justifyContent: "flex-start"}}>
        <div>
          <div style={{width: "420px", display: "flex", justifyContent: "flex-start", alignItems: "flex-start"}}>
            <Select
              className="form-element form-input scroll-to-chargeClassId correct-label-position"
              error={this.getErrorFor("chargeClassId")}
              style={{width: "30%", marginRight: "10px"}}
              disabled={!!this.state.paymentClassId}
              htmlFor="chargeClassId"
              name="chargeClassId" 
              id="chargeClassId"
              value={Number(classId)}
              onChange={this.changeClassIdForCharge}
              label={this.trans("section/charge-field/class-label")}
            >
              <MenuItem
                key={`chargeClassId-${ChargeClassContainer.pickIdFromLabel("Receivable")}`}
                value={ChargeClassContainer.pickIdFromLabel("Receivable")}
              >
                {this.trans("section/charge-field/classreceivable-label")}
              </MenuItem>
              <MenuItem
                key={`chargeClassId-${ChargeClassContainer.pickIdFromLabel("Payable")}`}
                value={ChargeClassContainer.pickIdFromLabel("Payable")}
              >
                {this.trans("section/charge-field/classpayable-label")}
              </MenuItem>
            </Select>
            <div style={{fontStyle: "italic", marginTop: "20px"}}>
              {Number(classId) == ChargeClassContainer.pickIdFromLabel("Receivable") ? this.trans("section/charge-field/classreceivableexplanation-label", {agencyName: this.getAgency().name}) : this.trans("section/charge-field/classpayableexplanation-label", {agencyName: this.getAgency().name})}
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "420px",
            }}
          >
            <div style={{display: "flex", flexDirection: "column", width: "70%", marginRight: "10px"}}>
              <TextField
                autoComplete="off"
                //id="amountForCharge"
                className="form-element full-size scroll-to-amountForCharge"
                type="text"
                label={this.trans("section/charge-field/аmount-label")}
                value={this.state.amountForCharge}
                onChange={this.changeAmountForCharge}
                variant="standard"
                autoFocus={!!this.props.autoFocusAmount}
                error={!!this.getErrorFor("amountForCharge")}
                helperText={this.getErrorFor("amountForCharge")}
              />
            </div>

            <Select
              className="form-element form-input scroll-to-currencyIdForCharge correct-label-position"
              style={{width: "30%"}}
              error={this.getErrorFor("currencyIdForCharge")}
              value={this.state.currencyIdForCharge}
              onChange={this.changeCurrencyIdForCharge}
              htmlFor="currencyIdForCharge"
              // label={{this.trans("section/charge-field/currency-label")}}
              name="currencyIdForCharge" 
              id="currencyIdForCharge"
            >
              {this.getCurrencySelectboxes()}
            </Select>
          </div>

          {Number(classId) == ChargeClassContainer.pickIdFromLabel("Receivable") && (
            <div style={{width: "420px"}}>
              <div style={{/*margin: "15px 0 0 0"*/}}>
                {!!this.state.showChargeOwnerChoice && this.renderCounterpartyField(classId)}
              </div>
              <div style={{/*margin: "-20px 0 0 0"*/}}>
                {this.renderBankAccountField(classId)}
              </div>
            </div>
          )}
          
          {Number(classId) == ChargeClassContainer.pickIdFromLabel("Payable") && (
            <div style={{width: "420px"}}>
              <div style={{/*margin: "-5px 0 0px 0"*/}}>
                {this.renderBankAccountField(classId)}
              </div>
              <div>
                {!!this.state.showChargeOwnerChoice && this.renderCounterpartyField(classId)}
              </div>
            </div>
          )}

          <div className="search-bar-container" style={{/*margin: "-20px 0 10px 0"*/}}>
            <Searchbar
              {...this.props}
              id="selectedEntityForCharge"
              className={"scroll-to-objectId"}
              // floatingLabelText={labelText}
              floatingLabelText={this.trans("section/charge-field/for-label")}
              allResults={true}
              objectField={true}
              onChange={this.selectEntityForCharge}
              onClear={this.clearEntityForCharge}
              selectedEntity={this.state.selectedEntityForCharge}
              searchParameter={"objectForChargeSearch"}
              error={this.getErrorFor("objectId")}
              showClickThroughLink={true}
              searchText={this.state.selectedEntityForCharge ? `${this.state.selectedEntityForCharge.nameOfEntity}, ${this.state.selectedEntityForCharge.displayName}` : null}
            />
            <div className="hint-styles-dialog">
              {this.trans("section/charge-for-hint")}
            </div>
          </div>

          <div style={{width: "420px"}}>
            {this.state.renderChargeType === TypeContainer.pickIdFromLabel("Settlement") && (
              <Select
                className="form-element full-size form-input scroll-to-typeIdForCharge correct-label-position"
                error={this.getErrorFor("typeIdForCharge")}
                style={{marginRight: "15px"}}
                value={this.state.typeIdForCharge}
                onChange={this.changeTypeIdForCharge}
                htmlFor="type"
                label={this.trans("section/charge-field/type-label")}
                name="type" 
                id="type"
              >
                {
                  TypeContainer.getSettlementType().map((type,index) => {
                    return (
                      <MenuItem key={index} value={type.id}>{`${Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
                    );
                  })
                }
              </Select>
            )}

            {this.state.renderChargeType === TypeContainer.pickIdFromLabel("Payout_receivable") && (
              <Select
                className="form-element full-size form-input scroll-to-typeIdForCharge correct-label-position"
                error={this.getErrorFor("typeIdForCharge")}
                style={{marginRight: "15px"}}
                value={this.state.typeIdForCharge}
                onChange={this.changeTypeIdForCharge}
                htmlFor="type"
                label={this.trans("section/charge-field/type-label")}
                name="type" 
                id="type"
              >
                {
                  TypeContainer.getPayoutReceivableType().map((type,index) => {
                    return (
                      <MenuItem key={index} value={type.id}>{`${Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
                    );
                  })
                }
              </Select>
            )}

            {this.state.renderChargeType === TypeContainer.pickIdFromLabel("Payout_payable") && (
              <Select
                className="form-element full-size form-input scroll-to-typeIdForCharge correct-label-position"
                error={this.getErrorFor("typeIdForCharge")}
                style={{marginRight: "15px"}}
                value={this.state.typeIdForCharge}
                onChange={this.changeTypeIdForCharge}
                htmlFor="type"
                label={this.trans("section/charge-field/type-label")}
                name="type" 
                id="type"
              >
                {
                  TypeContainer.getPayoutPayableType().map((type,index) => {
                    return (
                      <MenuItem key={index} value={type.id}>{`${Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
                    );
                  })
                }
              </Select>
            )}

            {
              this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Settlement") &&
              this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Payout_receivable") &&
              this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Payout_payable") && (
                <Select
                  className="form-element full-size form-input scroll-to-typeIdForCharge correct-label-position"
                  error={this.getErrorFor("typeIdForCharge")}
                  variant="standard"
                  value={this.state.typeIdForCharge}
                  onChange={this.changeTypeIdForCharge}
                  htmlFor="type"
                  label={this.trans("section/charge-field/type-label")}
                  name="type" 
                  id="type"
                >
                  {
                    TypeContainer.getChargeTypes(Number(classId) == ChargeClassContainer.pickIdFromLabel("Payable") ? "payable" : "receivable")
                    .filter(chargeType => {
                      
                      if((TypeContainer.pickIdFromLabel("Savings_account_withdraw") === chargeType.id || TypeContainer.pickIdFromLabel("Savings_account_deposit") === chargeType.id)  &&  (this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Savings_account_withdraw") && this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Savings_account_deposit"))) {
                        return false;
                      }

                      if((TypeContainer.pickIdFromLabel("Stub_receivable") === chargeType.id || TypeContainer.pickIdFromLabel("Stub_payable") === chargeType.id)  &&  (this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Stub_receivable") && this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Stub_payable"))) {
                        return false;
                      }

                      if (!!this.state.typeIdForCharge && chargeType.removed && (chargeType.id === this.state.typeIdForCharge)) {
                        return true;
                      }

                      if (chargeType.removed) {
                        return false;
                      }

                      return true;
                    })
                    .map((type, index) => {
                      return (
                        <MenuItem key={`chargeType-${index}`} value={type.id} disabled={(type.id === -1 || type.id === -2)}>{`${type.id === -1 || type.id === -2 ? type.label : Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
                      );
                    })
                  }
                  {
                    (TypeContainer.pickIdFromLabel("Credit_receivable") === this.state.charge?.type?.id || TypeContainer.pickIdFromLabel("Credit_payable") === this.state.charge?.type?.id) && <MenuItem key={`chargeType-${this.state.charge?.type?.id}`} value={this.state.charge?.type?.id}>{this.trans(`${TypeContainer.pickIdFromLabel("Credit_payable") === this.state.charge?.type?.id ? "credit_payable": "credit_receivable"}`)}</MenuItem>
                  }
                  {/*  <MenuItem
                    className="add-charge-type-div button-add-wrapper"
                  >
                    <Button
                      style={{width: "100%"}}
                      className="add-charge-type-button color-button-add"
                      color="primary"
                      onClick={() => this.setState({isCreateChargeTypePopupOpen: true})}
                    >
                      {this.trans("dropdown/chargetype-button/newchargetype")}
                    </Button>
                  </MenuItem>  */} 
                </Select>
              )
            }
          </div>

          <div style={{width: "420px"}}>
            <TextField
              autoComplete="off"
              id="descriptionForCharge"
              name="descriptionForCharge"
              className="form-element full-size scroll-to-descriptionForCharge"
              type="text"
              label={this.trans("section/charge-field/description-label") + this.trans("field/optional")}
              value={this.state.descriptionForCharge}
              onChange={this.changeDescriptionForCharge}
              multiline={true}
              rowsMax={10}
              onKeyPress={() => {
                if(!this.state.descriptionForChargeIsManuallyChanged) {
                  this.setState({descriptionForChargeIsManuallyChanged: true});
                }
              }}
              variant="standard"
              error={!!this.getErrorFor("descriptionForCharge")}
            />
            {!!this.getErrorFor("descriptionForCharge") && <div className="component-error-text">{this.getErrorFor("descriptionForCharge")}</div>}

            <DatePickerComponent
              {...this.props}
              id="dateOfPeriodForCharge"
              name="dateOfPeriodForCharge"
              className={"form-element scroll-to-dateOfPeriodForCharge"}
              label={this.trans("charge-for-period")}
              initialDate={this.state.dateOfPeriodForCharge}
              onChange={date => this.selectDate(date, "dateOfPeriodForCharge")}
              clearButton={true}
              openTo={"month"}
              views={["year", "month"]}
              disableKeyboard={true}
              error={this.getErrorFor("dateOfPeriodForCharge")}
            />

            <DatePickerComponent
              {...this.props}
              id="firstDateForCharge"
              name="firstDateForCharge"
              className={"form-element scroll-to-firstDateForCharge"}
              label={this.trans("section/charge-field/forperiod-label")}
              initialDate={this.state.firstDateForCharge}
              onChange={date => this.selectDate(date, "firstDateForCharge")}
              clearButton={true}
              openTo={"month"}
              views={["year", "month"]}
              disableKeyboard={true}
              error={this.getErrorFor("firstDateForCharge")}
              financialStatementId={this.props.charge?.ownerFinancialStatementId}
            />
          </div>
        </div>

        <div style={{position: "relative", marginLeft: "50px"}}>
          {
            this.state.showInvoiceSwitch &&
            <div style={{position: "absolute", top: "/*-20px*/"}}>
              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.isInvoice}
                    onChange={this.handleChangeIsInvoice}
                    color="primary"
                  />
                  }
                label={this.trans("page/chargecreate-field/invoiceswitch-label")}
              />
            </div>
          }
          {this.state.isInvoice && this.renderInvoiceFields()}
        </div>
      </div>
    );
  }

  public renderInvoiceFields = () => {
    return (
      <div style={{display: "flex", flexDirection: "column", padding: "21px 20px 0 0", minWidth: "200px"}}>
        <DatePickerComponent
          {...this.props}
          className={"full-size invoice-block scroll-to-invoiceDateForCharge"}
          label={this.trans("section/charge-field/invoicedate-label")}
          initialDate={this.state.invoiceDateForCharge}
          onChange={date => this.selectDate(date, "invoiceDateForCharge")}
          clearButton={true}
          error={this.getErrorFor("invoiceDateForCharge")}
        />

        <TextField
          autoComplete="off"
          //id="invoiceNumberForCharge"
          className="full-size invoice-block scroll-to-invoiceNumberForCharge"
          type="text"
          label={this.trans("section/charge-field/invoicenumber-label")}
          value={this.state.invoiceNumberForCharge}
          onChange={this.changeInvoiceNumberForCharge}
          variant="standard"
          error={!!this.getErrorFor("invoiceNumberForCharge") || !!this.getErrorFor("invoiceNumber")}
        />
        {(!!this.getErrorFor("invoiceNumberForCharge") || !!this.getErrorFor("invoiceNumber")) &&  <div className="component-error-text">{this.getErrorFor("invoiceNumberForCharge") || this.getErrorFor("invoiceNumber")}</div>}
        
        {
          this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Payout_receivable") &&
          this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Payout_payable") && (
            <div style={{display: "flex", flexDirection: "column"}}>
              <TextField
                autoComplete="off"
                //id="vatForCharge"
                className="full-size scroll-to-vatForCharge invoice-block"
                type="text"
                label={this.trans("section/invoice-field/vat-label")}
                value={this.state.vatForCharge}
                onChange={this.changeVatForCharge}
                variant="standard"
                error={!!this.getErrorFor("vatForCharge")}
              />
              {!!this.getErrorFor("vatForCharge") &&  <div className="component-error-text">{this.getErrorFor("vatForCharge")}</div>}
              
              <TextField
                autoComplete="off"
                className="full-size invoice-block scroll-to-vatPercentageForCharge"
                type="text"
                label={this.trans("section/invoice-field/vatpercentage-label")}
                value={this.state.vatPercentageForCharge}
                onChange={this.changeVatPercentageForCharge}
                variant="standard"
                error={!!this.getErrorFor("vatPercentageForCharge")}
              />
              {!!this.getErrorFor("vatPercentageForCharge") && <div className="component-error-text">{this.getErrorFor("vatPercentageForCharge")}</div>}
            </div>
          )
        }

        {
          (this.state.renderChargeType === TypeContainer.pickIdFromLabel("Payout_receivable") ||
          this.state.renderChargeType === TypeContainer.pickIdFromLabel("Payout_payable")) && 
          this.state.charge?.collectiveVat?.map(vat => {
            return (
              <div style={{display: "flex", flexDirection: "column"}}>
                <TextField
                  autoComplete="off"
                  //id="vatForCharge"
                  className="full-size invoice-block scroll-to-vatForCharge"
                  type="text"
                  label={this.trans("section/invoice-field/vat-label")}
                  value={this.formatter.formatNumber(vat.totalVatAmount)}
                  // onChange={this.changeVatForCharge}
                  variant="standard"
                  error={!!this.getErrorFor("vatForCharge")}
                />
                {!!this.getErrorFor("vatForCharge") &&  <div className="component-error-text">{this.getErrorFor("vatForCharge")}</div>}
                
                <TextField
                  autoComplete="off"
                  className="full-size invoice-block scroll-to-vatPercentageForCharge"
                  type="text"
                  label={this.trans("section/invoice-field/vatpercentage-label")}
                  value={vat.percentage}
                  // onChange={this.changeVatPercentageForCharge}
                  variant="standard"
                  error={!!this.getErrorFor("vatPercentageForCharge")}
                />
                {!!this.getErrorFor("vatPercentageForCharge") && <div className="component-error-text">{this.getErrorFor("vatPercentageForCharge")}</div>}
              </div>
            );
          })
        }
      </div>
    );
  }

  public render() {
    const classId = this.state.chargeClassId || this.state.paymentClassId;

    let labelText;
    
    if (this.props.pageName) {
      if (this.props.withoutTabs){
        labelText = this.trans(`page/${this.props.pageName}-section/charge-field/object-label`)
      } else {
        labelText = this.trans(`page/${this.props.pageName}-section/charge-tab/newcharge-field/object-label`)
      }
    }

    return (
      <div style={{padding: "20px 0 0 0"}}>
        <div style={{width: "420px"}}>
          {this.state.isSettle &&
            <div style={{color: "rgb(0, 188, 212)", fontSize: "14px", margin: "0 0 10px 0"}}>{this.trans("page/chargeupdate-section/charge-info/cantupdatesettlecharge")}</div>
          }
          {this.state.hasSettlementType &&
            <div style={{color: "rgb(0, 188, 212)", fontSize: "14px", margin: "0 0 10px 0"}}>{this.trans("page/chargeupdate-section/charge-info/specialcreatedsettlecharge")}</div>
          }
          {this.state.isLocked && (<div style={{color: "#00BCD4", fontSize: "14px", margin: "0 0 10px 0"}}>{this.trans("section/charge-info/islocked")}</div>)}
          {this.state.isRemoved && (<div style={{color: "#00BCD4", fontSize: "14px", margin: "0 0 10px 0"}}>{this.trans("section/charge-info/isremoved")}</div>)}
          {this.state.hasSavingsType &&
            <div style={{color: "rgb(0, 188, 212)", fontSize: "14px", margin: "0 0 10px 0"}}>{this.trans("page/chargeupdate-section/charge-info/specialcreatedsavingscharge")}</div>
          }
        </div>

        {this.renderCharge(classId, labelText)}

        <div style={{marginTop: "30px"}}>
          <Attachment
            {...this.props}
            typeOfComponent="shared"
            title={this.props.isInvoice ? this.trans("attachments-for-invoice") : this.trans("attachments-for-charge")}
            amazonFolderName={this.props.amazonFolderName}
            relation="chargeId"
            entity={this.state.charge}
            attachments={this.state.attachments}
            onChangeAvatar={avatar => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).change(avatar)}
            onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
            updateParentState={attachments => this.setState({attachments: attachments})}
            isDisabled={!!this.state.charge ? this.state.charge.removed : false}
            isCardView={true}
          />
        </div>

        <CoachNewCounterpartyDialog
          {...this.props}
          openCoachCreateNewCounterparty={this.state.openCoachCreateNewCounterparty}
          onCloseCounterpartyCoach={entity => {
            if(entity) {
              this.setState({
                openCoachCreateNewCounterparty: false            
              }, () => {this.selectCounterpartyForCharge(entity)})
            } else {
              this.setState({
                openCoachCreateNewCounterparty: false  
              })          
            }
          }}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("dialog/chargetype-title")}
          content={
            <ChargeTypeCreate
              {...this.props}
              onSaveType={this.addChargeType}
              onCancelType={this.closeChargeTypeCreateDialog}
              chargeTypeSelectField={Number(classId) == ChargeClassContainer.pickIdFromLabel("Payable") ? "Payable" : "Receivable"}
            />
          }
          openLeavePrompt={this.state.isCreateChargeTypePopupOpen}
          withoutDefaultDilaogButtons={true}
          onClose={this.closeChargeTypeCreateDialog}
        />
      </div>
    );
  }
}
